import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import pauseIcon from 'src/assets/icons/pause.svg';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

import ImagesSavedCard from './ImagesSavedCard';

interface PauseExamModalProps {
  show: boolean;
  description?: string;
  transparentBackdrop?: boolean;
}

export default function PauseExamModal({
  show,
  description,
  transparentBackdrop = false,
}: PauseExamModalProps) {
  const history = useHistory();
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'connectionIssue.pauseExamModal',
  });

  return (
    <SmallModalTemplate
      show={show}
      icon={<img src={pauseIcon} alt={t('pauseImgAlt')} />}
      iconWrapperClassName="bg-warning-100"
      title={t('title')}
      description={description ?? t('description')}
      backdropClassName={
        transparentBackdrop
          ? 'connection-issue-backdrop modal-backdrop-transparent'
          : 'connection-issue-backdrop'
      }
      style={{ zIndex: 2000 }}
      card={<ImagesSavedCard />}
      rightButton={
        <Button
          variant="outline-gray-500"
          className="clear-exam-button button-slim"
          onClick={() => {
            history.push('/');
          }}
        >
          {t('backToOrders')}
        </Button>
      }
    />
  );
}
